<!--
	作者：Shujuan Sun
	时间：2017-04-24
	描述：车辆监控页面_右上角动态按钮组
-->
<template>
	 <!--车辆监控页面_右上角按钮组开始-->
	<div class="btn-group boot-button right_act_ctrl right_baidu_btn" role="group" aria-label="..."> 
		<a class="drawTool" :class="[currentMenu===0 ?'active':'normal-tool']" @click="makePlan(0)">
			<img src="../../../assets/project/images/map/text_icon_23.png" width="44" height="44" alt="规划"/>
		</a> 
		<a class="drawTool" :class="[currentMenu===1 ?'active':'normal-tool']" @click="streetView(1)">
			<img src="../../../assets/project/images/map/text_icon_28.png" width="44" height="44" alt="街景"/>
		</a> 
		<a v-if="permission.indexOf('vehicleMonitor_panelExpansionPointTrack') == -1" class="drawTool" :class="[currentMenu===2 ?'active':'normal-tool']" @click="addTrack(2)">
			<img src="../../../assets/project/images/map/text_icon_2b.png" width="44" height="44" alt="轨迹"/>
		</a>
		<button style="outline:none;" type="button" class="menu_btn right_act_btn" id="tool" @click="toggleMenu" :class="[rollUp?'downArrow':'upArrow']" data-toggle="vehicletip" data-placement="bottom" title="折叠"></button>
	</div>
	 <!--车辆监控页面_右上角按钮组结束-->
</template>
<script> 
	import {mapState} from 'vuex'
	export default{
		name:'MenuVehicle',
		data(){
			return {
				permission:this.$store.state.permission.permission["vehicleMonitor"]?this.$store.state.permission.permission["vehicleMonitor"]:[],
				currentMenu:'',
				rollUp:false
			}
		},
		props:['defendStatus','clickedInfo','carSearching','stopException'], 
		watch:{
			'clickedInfo.vehicleId'(val){
				//右上角menuVehicle初始化
				this.currentMenu = '' 
				//右侧悬浮框初始化：
				this.$store.dispatch('initMapTab')
			}
		},
		mounted(){
			$(function () {//启用tooltip
			  $('[data-toggle="vehicletip"]').tooltip()
			})
		}, 
		destroyed(){
			$('[data-toggle="vehicletip"]').tooltip('hide')
		},
		methods: {
			toggleMenu(){
				this.rollUp = !this.rollUp
				$(".btn-group .normal-tool").toggle(300);
				$(".btn-group .active").toggle(300);
			}, 
			addTrack(index){//添加车辆到轨迹队列
				this.currentMenu = index;
				const obj = {
					name:'救援车辆轨迹', 
					id:'PageVehicleTrace',
					route:'/indexhome/vehicleTrace',
					No:'vehicleTrace'
				}
				//1,跳转到轨迹回放页面 
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
				//2,追加到轨迹队列
				let arr = []
				arr.push(this.clickedInfo.vehicleId)
				const param = {
					vehicleIds:arr,
					type:4
				}
				this.$store.dispatch('addTrackList',param).then(()=>{
					this.$store.dispatch('getTraceList',1)
				})
			}, 
			streetView(index){//街景
				this.currentMenu = index;
				this.$emit('streetView')
			}, 
			makePlan(index){//规划
				this.currentMenu = index;
				this.$emit('makePlan')
			} 
		}
		
	}
</script> 


// WEBPACK FOOTER //
// MenuVehicle.vue?f195d4d2